<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">订单详情</h1>
            <div class="od_stus" style="background-color:#f00180">
                <p class="od_tt">
                    <img src="https://s.cccgx.com/mobile/asset/css/u/u_ods3.png" class="od_img">
                    {{orderInfo.status}}
                </p>
                <p class="od_sub">订单{{orderInfo.status}}</p>
            </div>
            <div class="ysd_box">
                <div class="u_ifo">
                    <img src="https://s.cccgx.com//themes/v4/css/u/u_od_dz.png" class="u_if_img">
                    <p class="u_if_name">{{orderInfo.mail_name}} {{orderInfo.mail_tel}}</p>
                    <p class="u_ifdress">{{orderInfo.mail_province}}{{orderInfo.mail_city}}{{orderInfo.mail_area}}{{orderInfo.mail_town}}{{orderInfo.mail_address}}</p>
                </div>
            </div>
            <!--one over-->
            <!--商品begin-->
            <div class="goods_bx">
                <div class="goods_pone goods_offs" v-for="(pro,index) in orderInfo.product" :key="index">
                    <router-link :to="{path:'/detail', query:{id:pro.pid}}" target="_blank" class="by_a">
                        <img :src="pro.piclink" width="45" height="45" class="by_pic">
                        <p class="by_tt">{{pro.title}}</p>
                        <p class="by_atr">{{pro.sku_cn}}</p>
                        <em class="by_price">¥{{$fnc.toFixedZ(pro.money)}}</em>
                        <em class="by_num">X{{pro.number}}</em>
                    </router-link>
                    <div class="over">
                        <a class="db_btn" href="javascript:;" @click="$router.push({path: '/orderrefund', query:{id:orderId,oid:orderInfo.oid,showVideo:1,uid:orderInfo.uid}})"  v-if="(pro_status == 1 || pro_status == 2 || pro_status == 3)">{{orderRefund}}</a>
                         <a class="db_btn" href="javascript:;" @click="closeOrder(orderId)"  v-if="(pro_status == 1 || pro_status == 2 || pro_status == 3)">取消退货</a> 

                        
                        <a class="db_btn" href="javascript:;" v-if="pro_status == 0 && orderRefund != null && orderRefund != ''" @click="$router.push({path: '/orderrefund', query:{id:pro.id,oid:orderInfo.oid,showVideo:1,uid:orderInfo.uid}})">申请退货</a>
                        <!-- <a class="db_btn" href="javascript:;" v-if="orderInfo.status=='已支付'">待收货</a> -->
                        <!-- <a class="db_btn" href="javascript:;" @click="$router.push({path: '/order_review', query:{id:orderInfo.id,oid:orderInfo.oid,showVideo:1,uid:orderInfo.uid}})" v-if="orderInfo.status=='已完成'">待评价</a> -->
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_review',query:{id:orderId,oid:orderInfo.oid,showVideo:1,uid:orderInfo.uid}})" v-if=" pro_status == '已完成' && (pro_status == 0 || pro_status == '0') && orderInfo.types != 25 ">{{orderInfo.is_review == 0 ? "待评价" : "已评价" }}</a>
                        <a class="db_btn" href="javascript:;" v-if="orderInfo.status=='已完成'">再次购买</a>
                        <!-- <a class="db_btn" href="javascript:;" v-if="orderInfo.status=='已发货'">查看物流</a> -->
                        <a class="db_btn" href="javascript:;" @click="subConfim(orderInfo.id)" v-if="orderInfo.status=='已发货'">确认收货</a>
                        <a class="db_btn" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="pro_status==4">退货成功</a>
                    </div>
                </div>
                <div class="wai" id="amlit">
                    <p class="over">
                        <em class="left">商品总价</em>
                        <em class="right">¥{{$fnc.toFixedZ(orderInfo.money)}}</em>
                    </p>
                    <p class="over">
                        <em class="left">优惠折扣</em>
                        <em class="right">¥{{$fnc.toFixedZ(orderInfo.red_money)}}</em>
                    </p>
                    <p class="over">
                        <em class="left">运费</em><em class="right">免邮</em>
                    </p>
                    <p class="btf"></p>
                    <div class="over">
                        <span class="left">{{pro_length}}件商品</span>
                        <p class="right">
                            总计<b class="red">¥</b>
                            <b class="red f16">{{$fnc.toFixedZ(orderInfo.money)}}</b>
                        </p>
                    </div>
                    
                    <!--wai over-->
                </div>
                <a class="db_btn" @click="$router.push({path: '/payorder',query:{id:ids,uid:orderInfo.uid,showVideo:1}})" v-if="orderInfo.status == '未支付'">立即支付</a>
                <a class="db_btn" @click="cancel_pay(orderId)" v-if="orderInfo.status=='未支付'">取消支付</a>
            </div>
            <!--商品over-->
            <div class="goods_bx od_pd2">
                <p class="od_ob">订单编号<em class="od_tle">{{orderInfo.oid}}</em></p>
                <p class="od_ob">下单日期<em class="od_tle">{{$fnc.getTimeFormat(orderInfo.pay_time)}}</em></p>
                <p class="od_ob">付款方式<em class="od_tle">{{orderInfo.pay}}</em>
                </p>
                <p class="od_ob">订单备注<em class="od_tle">{{orderInfo.remarks}}</em>
                </p>
            </div>
            <div class="order_msg">
                <h2 class="od_msgt">最新消息</h2>
                <div class="od_msg">
                    <p class="od_ob">订单状态<em class="od_tle">{{orderInfo.oid}}</em></p>
                    <p class="od_ob">支付状态<em class="od_tle">{{$fnc.getTimeFormat(orderInfo.pay_time)}}</em></p>
                    <p class="od_ob">物流状态<em class="od_tle">{{orderInfo.status}}</em>
                    </p>
                </div>
            </div>
            <div class="order_msg">
                <h2 class="od_msgt">物流最新消息</h2>
                <div class="od_msg">
                    <p class="od_ob">物流公司：<em class="od_tle">{{mailInfo.mail_courier}}</em></p>
                    <p class="od_ob">快递单号：<em class="od_tle">{{mailInfo.mail_oid}}</em></p>
                    <div class="od_ob">物流信息：
                        <div v-if="mailInfo.mail && mailInfo.mail.Traces">
                            <div v-for="(item,i) in mailInfo.mail.Traces" :key="i" >
                                <h3>{{item.AcceptStation}}</h3>
                                <p class="mail_time">{{item.AcceptTime}}</p>
                            </div>
                        </div>
                        <div v-else>暂未查找到物流信息</div>
                    </div>
                </div>
            </div>
            <div class="od_pd">
                <em class="bg_gi">隐私保护</em>
                <em class="bg_gi">加密手机号</em>
                <em class="bg_gi">伪装快递单</em>
                <em class="bg_gi">严密封闭包裹</em>
                <em class="bg_gi">全国6大仓库</em>
                <em class="bg_gi">售后无忧</em>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            orderInfo:[],
            pro_length:"",
            // mailInfo:"",
            mailInfo: {
                mail: {
                    Traces: []
                }
            },
            orderRefund:"",
            pro_status:"",
            orderId:"",
            ids:this.$route.query.id,
        }
    },
    created(){
        this.getOrderDetails();
        this.getMail();
    },
    methods:{
        getOrderDetails(){
            var params = {}
            params.id = this.$route.query.id || "";
            params.oid = this.$route.query.oid || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getOrder.getOrderDetail(params).then(res => {
                if(res.code == 200){
                    this.orderInfo = res.result;
                    var arr = res.result.product;
                    arr.forEach((item,i) => {
                        this.orderId = item.id;
                        this.orderRefund = item.order_return;
                        this.pro_status = item.status;
                    });
                    this.pro_length = this.orderInfo.product.length;
                }
            })
        },
        getMail(){
            var params = {}
            params.id = this.$route.query.id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getOrder.getMail(params).then(res => {
                if(res.code == 200){
                    this.mailInfo = res.result;
                }
            })
        },
        closeOrder(id) {
            this.$confirm(`是否确认取消退货？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.getOrder.closeOrderCancel({id,uid:JSON.parse(window.localStorage.getItem("user")).id}).then((res) => {
                    if (res.code == 200) {
                        this.$alert('取消成功', '提示', {
                            confirmButtonText: '确定',
                        }).then(()=>{
                            window.location.reload();    
                        });
                    }
                });
            }).catch(() => {});
        },
        subConfim(id) {
            //确认收货
            var message = "";
            if (this.orderInfo.types == 9) {
                message = "完成出行";
            } else if (this.orderInfo.types == 14 || this.orderInfo.types == 13) {
                message = "完成预约";
            } else if (this.orderInfo.types == 21) {
                message = "完成入住";
            } else {
                message = "收货";
            }
            this.$confirm(`是否确认${message}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.getOrder.getConfirm({id,uid:JSON.parse(window.localStorage.getItem("user")).id}).then((res) => {
                    if (res.code == 200) {
                        this.$alert(`${res.result}`, '提示', {
                            confirmButtonText: '确定',
                        }).then(()=>{
                            window.location.reload();    
                        });
                    }
                });
            }).catch(() => {});
        },
        cancel_pay(id) {
            var params = {};
            params.id = id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getOrder.cancel_pay(params).then((res) => {
                if (res.code == 200) {
                    this.$alert('取消成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                        window.location.reload();    
                    });
                    
                    this.$emit("openThis");
                } else {
                    // alert(res.result)
                    this.$alert(`${res.result}`, '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                        window.location.reload();    
                    });
                }
            });
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/order/order_detail.vue